import { Button, Card } from "react-bootstrap";
import { FORM_FIELDS, PRICE_LIST_TABLE_COLUMNS } from "../../Constants";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import PriceListImportArea from "./PriceListImportArea";

const StoreCard = ({
  Accordion,
  data,
  setStores,
  activeKey,
  setActiveKey,
  taxObligation,
}) => {
  const { STORE_DATA, CLIENT_DATA } = FORM_FIELDS;
  const { PRICE_LIST_DATA } = STORE_DATA;

  const rowClasses = (row, rowIndex) => {
    if (data.invalidRows?.[rowIndex]) return "invalid-record";
  };

  const updateStore = (newData) => {
    setStores((stores) => {
      const index = stores.findIndex((item) => item.tag === data.tag);
      const newStores = [...stores];
      const oldData = newStores[index];
      delete oldData.invalidRows;
      delete oldData.priceListTableData;
      delete oldData[PRICE_LIST_DATA.name];

      newStores[index] = {
        ...oldData,
        ...newData,
      };
      return newStores;
    });
  };

  const tableData = data.priceListTableData || [];

  return (
    <Card>
      <Accordion.Toggle
        as={Card.Header}
        eventKey={data.tag}
        onClick={() =>
          setActiveKey(activeKey === data?.tag ? undefined : data?.tag)
        }
      >
        <span>
          {"Naziv: "} {data?.[STORE_DATA.DESCRIPTION.name]} /{" OZNAKA:"}
          {data?.[STORE_DATA.TAG.name]} / {"Adresa:"}{" "}
          {data?.[STORE_DATA.STREET.name]}{" "}
          {data?.[STORE_DATA.STREET_NUMBER.name]}
        </span>
        <span>
          <i className={`fas fa-plus`}></i> Dodaj cjenik
        </span>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={data?.tag}>
        <div className="m-3">
          {tableData.length === 0 && (
            <PriceListImportArea
              setStore={updateStore}
              taxObligation={taxObligation}
            />
          )}
          {tableData.length > 0 && (
            <div className="d-flex justify-content-end mb-2">
              <Button onClick={() => updateStore({})}>Izbriši cjenik</Button>
            </div>
          )}

          {data?.invalidRows && Object.keys(data?.invalidRows)?.length > 0 && (
            <div className="invalid-record my-3 p-3">
              {Object.keys(data?.invalidRows).map((x) => (
                <p key={x} className="m-0">
                  Redak {Number(x) + 1}:{" "}
                  {data?.invalidRows[x].map((text, i) => (
                    <span key={i}>{text}, </span>
                  ))}
                </p>
              ))}
            </div>
          )}

          <BootstrapTable
            keyField={PRICE_LIST_DATA.ID.name}
            data={tableData}
            rowClasses={rowClasses}
            columns={PRICE_LIST_TABLE_COLUMNS}
            noDataIndication={"Nema podataka"}
            pagination={paginationFactory()}
          />
        </div>
      </Accordion.Collapse>
    </Card>
  );
};

export default StoreCard;
